import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RestrictPlanService {
  restrictionEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  showModal: boolean = false;

  
  constructor() { }


  isFeatureRestricted(featureKey: string): boolean {
    return localStorage.getItem(featureKey) === "false";
  }

    /**
   * Handles feature access:
   * - If restricted, show modal.
   * - Otherwise, execute the function.
   */
    handleFeatureAccess(featureKey: string, callback: Function) {
      if (this.isFeatureRestricted(featureKey)) {
        this.restrictionEvent.emit(true);  // Show modal
      } else {
        callback();  // Execute allowed function
      }
    }

    showUpgradeModal() {
      console.log("    showUpgradeModal------------");
      this.showModal = true;
    }
  
    closeModal() {
      this.showModal = false;
    }
    
}
